import * as ActionTypes from '../ActionTypes';
import * as ReduxDataStatus from '../../utils/constants/ReduxDataStatus';

import * as CognitoHelper from '../../utils/auth/CognitoHelper';

const getInitState = () => {
    console.log('<<<<< Init State >>>>>');

    const initState = {
        status: ReduxDataStatus.IDLE,
        isAuthenticated: CognitoHelper.isCurrentUserSessionActive() && localStorage.getItem('afUser') ? true : false,
        afUser: localStorage.getItem('afUser') ? JSON.parse(localStorage.getItem('afUser')) : null,
        cognitoUser: CognitoHelper.getCurrentUserFromUserPool(),
        subcontracted: [],
        errMess: null,
        cognitoState: null
    };

    return initState;
}

export const AuthReducer = (state = getInitState(), action) => {

// export const AuthReducer = (state = {
//         status: ReduxDataStatus.IDLE,
//         isAuthenticated: CognitoHelper.isCurrentUserSessionActive() && localStorage.getItem('afUser') ? true : false,
//         afUser: localStorage.getItem('afUser') ? JSON.parse(localStorage.getItem('afUser')) : null,
//         cognitoUser: CognitoHelper.getCurrentUserFromUserPool(),
//         subcontracted: [],
//         errMess: null,
//         cognitoState: null
//     }, action) => {
    switch (action.type) {
        case ActionTypes.LOGIN_REQUEST:
            return {...state,
                status: ReduxDataStatus.LOADING,
                isAuthenticated: false
            };

        case ActionTypes.LOGIN_SUCCESS:
            return {...state,
                status: ReduxDataStatus.SUCCEEDED,
                isAuthenticated: true,
                errMess: null,
                cognitoUser: action.payload.cognitoUser,
                afUser: action.payload.afUser,
                cognitoState: null
            };

        case ActionTypes.LOGIN_FAILURE:
            return {...state,
                status: ReduxDataStatus.SUCCEEDED,
                isAuthenticated: false,
                errMess: action.message,
                cognitoState: null
            };
    
        case ActionTypes.LOGIN_AUTH_CHALLENGE:
            return {...state,
                status: ReduxDataStatus.SUCCEEDED,
                isAuthenticated: false,
                errMess: null,
                cognitoState: {
                    authenticationChallenge: action.payload.authChallenge,
                    cognitoUser: action.payload.cognitoUser,
                    username: action.payload.username,
                    userAttributes: action.payload.userAttributes
                }
            };
    
        case ActionTypes.LOGIN_AUTH_CHALLENGE_SUCCESS:
            return {...state,
                status: ReduxDataStatus.SUCCEEDED,
                isAuthenticated: false,
                errMess: null,
                cognitoState: null
            };

        case ActionTypes.LOGIN_AUTH_CHALLENGE_FAILURE:
            return {...state,
                status: ReduxDataStatus.SUCCEEDED,
                isAuthenticated: false,
                errMess: action.message
            };
                    
        case ActionTypes.LOGOUT_REQUEST:
            return {...state,
                status: ReduxDataStatus.LOADING,
                isAuthenticated: true
            };

        case ActionTypes.LOGOUT_SUCCESS:
            return {...state,
                status: ReduxDataStatus.IDLE,
                isAuthenticated: false,
                cognitoUser: null,
                afUser: null,
                cognitoState: null
            };

        case ActionTypes.ADD_CLIENT_SUBCONTRACTED_BCU:
            return {...state,
                subcontracted: action.payload
            };
                
        default:
            return state
    }
}